<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <form class="mb-9">
                <div class="row justify-content-between align-items-end g-3 mb-5">
                    <div class="col-12 col-sm-auto col-xl-10">
                    <h2 class="mb-0">Artworks</h2>
                    </div>
                    <div class="col-12 col-sm-auto col-xl-2">
                        <div class="d-flex">
                            <router-link to="/create-artwork" class="btn btn-primary px-5 w-100 text-nowrap">New</router-link>
                        </div>
                    </div>
                </div>
                <div class="row g-5">
                    <div class="col-xl-12">
                        <div class="row gx-3 gy-4">
                            <div class="card" id="table" >
                                <div class="card-header">
                                    <div class="row align-items-center">
                                        <div class="col">
                                            <form>
                                                <div class="input-group input-group-flush input-group-merge input-group-reverse">
                                                    <span class="input-group-text search"><MagnifyIcon /></span>
                                                    <input class="form-control list-search" v-model="filtro" type="buscar" placeholder="Search..">
                                                </div>
                                            </form>
                                        </div>
                                    </div> 
                                </div>
                                <div class="table-responsive">
                                    <table class="table table-sm fs--1 mb-0">
                                        <thead>
                                        <tr>
                                            <th class="sort border-top"></th>
                                            <th class="sort border-top">Title</th>
                                            <th class="sort border-top">Description</th>
                                            <th class="sort border-top">State</th>
                                            <th class="sort border-top">Available at</th>
                                            <th class="sort border-top">Prints</th>
                                            <th class="sort border-top">Category</th>
                                            
                                            <th class="sort text-end align-middle pe-0 border-top" scope="col">
                                                <span class="nav-link-icon"><span data-feather="cog"></span></span>
                                            </th>
                                        </tr>
                                        </thead>
                                        <tbody >
                                            <tr v-for="(est,x) in filteredArtworks.reverse()" :key="x" class="row-clickable" @dblclick="abrir(est)">
                                                <td class="align-middle"><img class="rounded" style="width:100px" :src="thumb(est.featured)" alt="" loading="lazy" /></td>
                                                <td class="align-middle">{{est.title}}<br> <small>slug:{{est.slug }}</small></td>
                                                <td class="align-middle">Año: {{est.year}}<br>{{est.dimensions}}<br>{{est.media_es}}</td>
                                                <td class="align-middle">
                                                    <span v-if="est.is_available == 1" class="badge badge-iasc badge-iasc-success">Available</span>
                                                    <span v-else class="badge badge-iasc badge-iasc-secondary">Sold / Unavailable</span>
                                                
                                                    <span v-if="est.is_private == 1" class="badge badge-iasc badge-iasc-danger">Private</span>
                                                    <span v-else class="badge badge-iasc badge-iasc-success">Public</span>
                                                </td>
                                                <td class="align-middle"><span v-if="est.external_link != '' && est.external_link != 'undefined'">{{est.external_link}}</span><span v-else>{{est.contact_name}}</span></td>
                                                <td class="align-middle">{{(est.has_prints != '' ? 'SI' : 'NO')}} <br> {{est.external_link_print}}</td>
                                                <td class="align-middle">{{(est.category ? est.category : '')}}</td>
                                                
                                                <td class="align-middle white-space-nowrap text-end pe-0">
                                                    <button type="button" class="btn btn-sm btn-link p-1 row-action" title="Edit" @click.stop="abrir(est)">
                                                        <PencilOutlineIcon />
                                                    </button>
                                                    <button type="button" class="btn btn-sm btn-link p-1 row-action text-danger" title="Delete" @click.stop="borrar(est)">
                                                        <TrashCanOutlineIcon />
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                               
                                <div class="d-flex flex-between-center pt-3">
                                    <p class="mb-0 fs--1">
                                        <span class="d-none d-sm-inline-block" data-list-info="data-list-info">showing {{ filteredArtworks.length }} of {{ artworks.length }} </span>
                                        <span class="d-none d-sm-inline-block"> &mdash; </span>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </form>
        </div>
    </section>
  </template>
  
  <script>
  // @ is an alias to /src
  import SideBar from '@/components/SideBarNav.vue'
  import TopBar from '@/components/TopBarNav.vue'
  import axios from 'axios'
  import MagnifyIcon from 'vue-material-design-icons/Magnify.vue'
  import PencilOutlineIcon from 'vue-material-design-icons/PencilOutline.vue'
  import TrashCanOutlineIcon from 'vue-material-design-icons/TrashCanOutline.vue'

  export default {
    name: 'artworksView',
    components:{SideBar,TopBar,MagnifyIcon,PencilOutlineIcon,TrashCanOutlineIcon},
    data(){
        return{
            artworks:[],
            filtro:''
        }
    },
    created(){
        this.getData()
    },
    computed:{
        filteredArtworks(){
            let res = this.artworks.filter((e)=>{
                if(this.filtro != ''){
                    return (e.title) ? e.title.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.subtitle_en) ? e.subtitle_en.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.subtitle_es) ? e.subtitle_es.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.long_description) ? e.long_description.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.author) ? e.author.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.external_link) ? e.external_link.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.date) ? e.date.toLowerCase().includes(this.filtro.toLowerCase()) : '' ||
                           (e.short_description) ? e.short_description.toLowerCase().includes(this.filtro.toLowerCase()) : ''
                }else{
                    return e
                }
            })
            return res
        }
    },
    methods:{
        getData(){
             axios.get(this.$url+'/artworks',{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                this.artworks = res.data
                console.log(this.artworks)
            }).catch((err)=>{
                console.log(err)
            })
        },
        // Serve a cached 200px thumbnail instead of the full-size original.
        thumb(path){
            return path ? this.$url + '/thumb/200/' + path : ''
        },
        abrir(data){
            this.$router.push('/artwork/'+data.id)
        },
        borrar(data){
            axios.post(this.$url+'/artworks/delete/'+data.id,{},{
                headers: {
                    'Content-Type' : 'application/json',
                    'Authorization' : this.$store.state.token
                }
            })
            .then((res)=>{
                this.artworks = this.artworks.filter(e=>e != data.id)
            }).catch((err)=>{
                console.log(err)
            })
        }
    }
  }
  </script>
<style scoped>
/* rows open their edit page on double click */
.row-clickable{
    cursor: pointer;
}
.row-clickable:hover{
    background-color: rgba(0,0,0,.03);
}
/* the action icons keep their own pointer and stay above the row handler */
.row-action{
    cursor: pointer;
    text-decoration: none;
}
</style>
  
                    